import React from 'react'

import { NavLink, Route, Switch } from 'react-router-dom'

import ToolbarBackButton from './ToolbarBackButton'

import FamilyPlanSettings from "./FamilyPlanSettings";

class Settings extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      sessionId: props.sessionId,
      aid: props.accountId
    }
  }

  componentDidMount() {
  }

  render() {
    return (
      <div>

        <nav className="panel-toolbar">
          <ul>

            <li>
              <ToolbarBackButton />
            </li>

            <li>
              <NavLink to={`${this.props.match.url}`} activeClassName="active">
                <span className="material-icons md-36">groups</span>
                <br />
                <span className="icon-text">Family Plan</span>
              </NavLink>
            </li>

          </ul>
        </nav>

        <Switch>

          <Route
            exact
            path={`${this.props.match.url}`}
            render={({ match }) => (
              <FamilyPlanSettings
                    baseUrl={match.url}
                    device={this.props.device}
                    version={this.props.version}
                    aid={this.state.aid}
                    sessionId={this.state.sessionId}
                />
            )}
          />

        </Switch>

      </div>
    )
  }
}

export default Settings



// WEBPACK FOOTER //
// ./src/Components/Settings.js